module.exports = __webpack_public_path__ + "static/media/Taylor-Cahn.65060c2d.png";